export default {
  computed: {
    earned() {
      return [
        { title: 'Badge 1' },
        { title: 'Badge 2' },
      ];
    },
    current() {
      return [
        { title: 'Badge 3' },
        { title: 'Badge 4' },
      ];
    },
    toDiscover() {
      return [
        { title: 'Badge 5' },
        { title: 'Badge 6' },
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-badges-list/account-badges-list.js